import { StudioDataInstance } from '@gametailors/lp-studio-connector';

export class RecommendationsMockApi {
  /**
   * GET /generators/recommended-assignments/recommendation
   */
  public async generateRecommendedAssignments(): Promise<StudioDataInstance[]> {
    throw new Error('Not implemented');
  }
}
